if (window.location.pathname === '/apps/store-locator') {
    var style = document.createElement('style');
    style.innerHTML = `.oke-reviewsTab.oke-reviewsTab--small-top-left.oke-reviewsTab--large-top-left { display: none; }
      #MainContent #col-main { margin: 15px}
      .search_bar .main_search_label { display: none; }
      .search_bar .search_within_distance { display: none; }
      .search_bar .search_limit { display: none; }
      .search_bar + div  { visibility: hidden; }
      .search_bar::after {
        content: "";
        display: table;
        clear: both;
      }
      .search_bar {
        margin: 0 !important;
        padding: 0 !important;
        background: none !important;
        border: none !important;
        display: flex;
        gap: 1rem;
      }
      .main_search_bar, #submitBtn {
          float: none !important;
          width: auto !important;
      }
      .main_search_bar{
        width: 22%!important;
      }
      #address_search{
        display: flex !important;
        width: 100% !important;
        padding: 16px !important;
        justify-content: space-between !important;
        align-items: center !important;
        border-radius: 2px !important;
        border: 1px solid #D3D5D9 !important;
        background: #FFF !important;
        color: #605851;
        font-size: 14px;
        font-family: Helvetica Neue;
        letter-spacing: 0.98px;
      }
      #submitBtn{
        display: inline-flex !important;
        padding: 11px 36px !important;
        justify-content: center !important;
        align-items: center !important;
        gap: 8px !important;
        flex-shrink: 0 !important;
        border-radius: 2px !important;
        background: #605851 !important;
        margin: 0px !important;
      }
      #directions_text #direction_destination .name, .addresses li a .name {
        color: #1A1B18 !important;
        font-size: 22px !important;
        font-family: ArcherSemiboldPro !important;
        font-weight: 375 !important;
      }
      .addresses li a .name {
        width: 80% !important;
        outline: medium none !important;
        margin-bottom: 15px !important;
        text-decoration: none !important;
        display: inline-block !important;
        line-height: 2rem !important;
      }
      .addresses li {
        padding-left: 5rem !important;
      }
      button.button-map{
        display: flex;
        padding: 11px 36px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 2px;
        border: 1px solid #605851;
        background: #FFF;
        color: #605851;
        text-align: center;
        font-size: 12px;
        font-family: Helvetica Neue;
        font-weight: 500;
        letter-spacing: 0.84px;
        text-transform: uppercase;
        margin-top: 2rem;
      }
      .gm-style-iw.gm-style-iw-c{
        border-radius: 2px;
        border: 1px solid #F2F2F2;
        background: #FFF;
      }
      #store_map .name {
        color: #1A1B18 !important;
        font-size: 22px !important;
        font-family: ArcherSemiboldPro !important;
        font-weight: 375 !important;
        margin-bottom: 2rem;
        display: inline-block;
      }

      #directions_text #direction_destination, .addresses li{
        background-image: url(https://cdn.shopify.com/s/files/1/0736/9968/8738/files/location.svg?v=1687535229) !important;
      }

      .directions{
        clear: both;
        padding-top: 5px;
        color: #605851;
        text-decoration: none;
        font-size: 12px;
        font-family: Helvetica Neue;
        letter-spacing: 0.84px;
        text-decoration-line: underline;
        text-transform: uppercase;
        padding-top: 2rem !important; 
      }

      .gm_popup{
        color: #605851;
        font-size: 15px;
        font-family: ArcherSemiboldPro;
        font-weight: 375;
      }

      .addresses .directions{
        display: none;
      }

      .directions_step {
        clear: both;
      }

      #directions_steps .directions_instructions, #directions_steps .directions_step_distance, .distance {
        float: none !important;
        width: auto !important;
      }

      @media (max-width: 800px){
        .search_bar .main_search_bar {
          width: 100% !important;
          margin-bottom: 0px !important;
        }

        .search_bar button{
          height: auto !important;
        }
      `;
    document.head.appendChild(style);
  }

  // Get the elements you want to update
  let directionsText = document.querySelector('#directions_text #direction_destination');
  let addressesDiv = document.querySelectorAll('.addresses li');

  // Update the background image for directionsText with SVG
  directionsText.style.backgroundImage =
    'url(data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"%3E%3Cg id="vuesax/linear/location"%3E%3Cg id="vuesax/linear/location_2"%3E%3Cg id="location"%3E%3Cpath id="Vector" d="M11.9999 13.4299C13.723 13.4299 15.1199 12.0331 15.1199 10.3099C15.1199 8.58681 13.723 7.18994 11.9999 7.18994C10.2768 7.18994 8.87988 8.58681 8.87988 10.3099C8.87988 12.0331 10.2768 13.4299 11.9999 13.4299Z" stroke="%23605851" stroke-width="1.5"%3E%3C/path%3E%3Cpath id="Vector_2" d="M3.61995 8.49C5.58995 -0.169998 18.42 -0.159997 20.38 8.5C21.53 13.58 18.37 17.88 15.6 20.54C13.59 22.48 10.41 22.48 8.38995 20.54C5.62995 17.88 2.46995 13.57 3.61995 8.49Z" stroke="%23605851" stroke-width="1.5"%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A)';

  // Update the background image for each address element with SVG
  addressesDiv.forEach((address) => {
    address.style.backgroundImage =
      'url(data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"%3E%3Cg id="vuesax/linear/location"%3E%3Cg id="vuesax/linear/location_2"%3E%3Cg id="location"%3E%3Cpath id="Vector" d="M11.9999 13.4299C13.723 13.4299 15.1199 12.0331 15.1199 10.3099C15.1199 8.58681 13.723 7.18994 11.9999 7.18994C10.2768 7.18994 8.87988 8.58681 8.87988 10.3099C8.87988 12.0331 10.2768 13.4299 11.9999 13.4299Z" stroke="%23605851" stroke-width="1.5"%3E%3C/path%3E%3Cpath id="Vector_2" d="M3.61995 8.49C5.58995 -0.169998 18.42 -0.159997 20.38 8.5C21.53 13.58 18.37 17.88 15.6 20.54C13.59 22.48 10.41 22.48 8.38995 20.54C5.62995 17.88 2.46995 13.57 3.61995 8.49Z" stroke="%23605851" stroke-width="1.5"%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A)';
  });

  // Get the <a> elements inside the addresses list
  let links = document.querySelectorAll('#addresses_list a');

  // Iterate over each <a> element
  for (let i = 0; i < links.length; i++) {
    let link = links[i];

    // Create a button element
    let button = document.createElement('button');
    button.textContent = 'View on Map';
    button.className = 'button-map';

    link.appendChild(button);
  }